module.exports = __webpack_public_path__ + "media/images/front/img_clinicpage-4e8e4cf392ef0a33dce1b43696dab691.jpg";